<template>
  <div>
    <v-container class="pt-0 pb-10">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <v-btn color="primary-dark" @click="$router.push({ name: 'Administration' })" density="compact"
              variant="outlined">
              <v-icon left>mdi-arrow-left</v-icon>
              Retour
            </v-btn>
            <div class="text-h6 mt-2 mb-4">Recherche d'un remboursement à effectuer</div>
            <v-row class="d-flex align-center">
              <v-col cols="3">
                <label class="field_label">Rechercher une commande par :</label>
                <v-autocomplete :items="$itemsSelect.admin_search_refund_commandes_by_mode()"
                  v-model="search_by"></v-autocomplete>
              </v-col>
              <v-col cols="3">
                <label class="field_label">Valeur :</label>
                <v-text-field v-model="search_value"></v-text-field>
              </v-col>
              <v-col>
                <v-btn color="primary-dark" @click="search_commandes()" variant="tonal">
                  <v-icon left>mdi-magnify</v-icon>
                  Rechercher
                </v-btn>
              </v-col>
            </v-row>
            <div v-if="commandes.length > 0">
              <CommandeItem v-for="commande in commandes" :commande="commande" :key="commande.id"></CommandeItem>
            </div>
            <div v-else-if="commandes.length == 0 && launch_search">Aucune commande ne correspond à ces critères de
              recherche</div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

import axios from "axios";
import CommandeItem from "@/components/Administration/Search_Refund/Commande_Item.vue";

export default {
  components: { CommandeItem },
  data() {
    return {
      search_by: "email",
      search_value: "",
      commandes: [],
      launch_search: false,
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async search_commandes() {
      let params = this.get_params();
      this.launch_search = true;
      let res = await axios.get("/administration/search_refund/get.php?id_module=" + this.mainStore.module.id + params);
      if (res.data.error) {
        console.log(res.data.error);

        return await false;
      } else {
        this.commandes = res.data;
        return await true;
      }
    },
    get_params() {
      return "&" + this.search_by + "=" + this.search_value;
    },
  },
  mounted() {

  },
};
</script>

<style lang="scss" scoped></style>